import './styles/main_dark.css';

import { NeuronAnimation } from './components/neuron_animation';
import { ResumeDownloader } from './utils/resume_downloader';
import { AnimationObserver } from './utils/animation_observer';
import { SmoothScrollNavigation } from './utils/smooth_navigation';

class QuantarienApp {

  private neuronAnimation: NeuronAnimation;
  private resumeDownloader: ResumeDownloader;
  private animationObserver: AnimationObserver;
  private smoothNavigation: SmoothScrollNavigation;

  constructor() {

    this.neuronAnimation = new NeuronAnimation();
    this.resumeDownloader = new ResumeDownloader();
    this.animationObserver = new AnimationObserver();
    this.smoothNavigation = new SmoothScrollNavigation()
    
    this.init();
  }

  private init(): void {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeApp());
    } else {
      this.initializeApp();
    }
  }

  private initializeApp(): void {
    // Initialize all components
    this.smoothNavigation.init();
    this.neuronAnimation.init();
    this.resumeDownloader.init();
    this.animationObserver.init();

    // Set up global event listeners
    this.setupGlobalEventListeners();
    
    console.log('Quantarien website initialized successfully!');
  }

  private setupGlobalEventListeners(): void {
    // Close mobile menu when clicking outside
    document.addEventListener('click', (event: Event) => {
      const navLinks = document.getElementById('navLinks');
      const mobileMenu = document.querySelector('.mobile-menu');
      const target = event.target as Element;

      
      if (navLinks && mobileMenu && 
          !navLinks.contains(target) && 
          !mobileMenu.contains(target)) {
        navLinks.classList.remove('active');
      }
    });

    // Handle photo upload placeholder
    const photoPlaceholder = document.querySelector('.profile-photo-placeholder');
    if (photoPlaceholder) {
      photoPlaceholder.addEventListener('click', this.handlePhotoUpload);
    }
  }

  private handlePhotoUpload(): void {
    alert(`To add your profile photo:

1. Replace the placeholder with your photo
2. Save your photo as "profile-photo.jpg"
3. Update the HTML to use: <img src="profile-photo.jpg" alt="Your Name" class="profile-photo">
4. Comment out or remove the placeholder div`);
  }
}

// Initialize the application
new QuantarienApp();